import {
  replaceHistory,
  replaceHistoryRemoveParams,
} from "@tm/insurance/utils";

/** `segment` query param mirrors `planType` (same id) for funnel parity with desktop. */
export function replaceHistoryPlanTypeAndSegment(planTypeId: string) {
  replaceHistory("planType", planTypeId);
  replaceHistory("segment", planTypeId);
}

export function replaceHistoryRemovePlanTypeAndSegment() {
  replaceHistoryRemoveParams("planType");
  replaceHistoryRemoveParams("segment");
}

/** If only one of planType/segment is set, copy to the other. If both differ, `planType` wins. */
export function mirrorPlanTypeSegmentInUrl() {
  if (typeof window === "undefined") return;
  const u = new URLSearchParams(window.location.search);
  const pt = u.get("planType");
  const seg = u.get("segment");
  if (pt && seg && pt !== seg) {
    replaceHistory("segment", pt);
  } else if (pt && !seg) {
    replaceHistory("segment", pt);
  } else if (!pt && seg) {
    replaceHistory("planType", seg);
  }
}

export function parseUnix(value?: number) {
  if (!value) return undefined;
  const ts = value > 1000000000000 ? value : value * 1000;
  return new Date(ts);
}
